import { connect } from 'react-redux';
import Comments from './container';
import { ID as ContainerID } from '../../../actionTypes';
import { clearUpdatedComment } from '../../../actions';

const mapStateToProps = (state) => {
    const {
        [ContainerID]: {
            lastUpdatedCommentId,
        },
    } = state;
    return {
        lastUpdatedCommentId,
    };
};

export default connect(mapStateToProps, {
    clearUpdatedComment,
})(Comments);
